export default "__VITE_ASSET__Cw$oUH2E__"